export const getReportNetworkLoading = (...flags: Array<boolean | null | undefined>): boolean =>
  flags.some(Boolean);
